module.exports = __webpack_public_path__ + "static/media/m10.93c451cc.png";